import React from 'react'

import InputV2 from 'components/InputV2'
import GhostRadioV2 from 'components/GhostRadioV2'
import ArrowIcon from 'containers/ProfileV2/images/ic-arrow.component.svg'

import {
  Form,
  FormInputs,
  InputsSection,
  CustomInputsRow,
  InputWrapper,
  RadiosWrapper,
  WrapperSelect,
  StyledSelect,
  InputLabel,
  Error,
} from './styles'

const AddressForm = (props) => {
  const {
    changeField,
    loading,
    tab,
    renderBtns,
    billingAddress,
    directDebit,
    street,
    door,
    floor,
    district,
    municipality,
    billingStreet,
    billingDoor,
    billingFloor,
    billingDistrict,
    billingMunicipality,
    electronicBilling,
    districts,
    municipalities,
    billingMunicipalities,
  } = props

  const _renderAddressInputs = (type) => {
    const streetField = type === 'contract' ? street : billingStreet
    const doorField = type === 'contract' ? door : billingDoor
    const floorField = type === 'contract' ? floor : billingFloor
    const districtField = type === 'contract' ? district : billingDistrict
    const municipalityField =
      type === 'contract' ? municipality : billingMunicipality

    return (
      <div className='rowsWrapper'>
        <CustomInputsRow>
          <InputWrapper>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Morada'
              type='text'
              value={streetField.value}
              onChange={(val) =>
                changeField(
                  'billing',
                  type === 'contract' ? 'street' : 'billingStreet',
                  val
                )
              }
              valid={!Boolean(streetField.valid)}
              errorMessage={streetField.valid}
            />
          </InputWrapper>
        </CustomInputsRow>

        <CustomInputsRow>
          <InputWrapper>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Porta'
              type='text'
              value={doorField.value}
              onChange={(val) =>
                changeField(
                  'billing',
                  type === 'contract' ? 'door' : 'billingDoor',
                  val
                )
              }
              valid={!Boolean(doorField.valid)}
              errorMessage={doorField.valid}
            />
          </InputWrapper>

          <InputWrapper>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Andar'
              type='text'
              value={floorField.value}
              onChange={(val) =>
                changeField(
                  'billing',
                  type === 'contract' ? 'floor' : 'billingFloor',
                  val
                )
              }
              valid={!Boolean(floorField.valid)}
              errorMessage={floorField.valid}
            />
          </InputWrapper>
        </CustomInputsRow>

        <CustomInputsRow>
          <WrapperSelect>
            <InputLabel>Distrito</InputLabel>
            <StyledSelect
              items={districts}
              placeholder={'Distrito'}
              onChange={({ value }) =>
                changeField(
                  'billing',
                  type === 'contract' ? 'district' : 'billingDistrict',
                  value
                )
              }
              selected={districtField.value}
              arrowIcon={ArrowIcon}
            />
            {Boolean(districtField.valid) && (
              <Error>{districtField.valid}</Error>
            )}
          </WrapperSelect>
          <WrapperSelect>
            <InputLabel>Concelho</InputLabel>
            <StyledSelect
              items={
                type === 'contract' ? municipalities : billingMunicipalities
              }
              placeholder={'Concelho'}
              onChange={({ value }) =>
                changeField(
                  'billing',
                  type === 'contract' ? 'municipality' : 'billingMunicipality',
                  value
                )
              }
              selected={municipalityField.value}
              arrowIcon={ArrowIcon}
            />
            {Boolean(municipalityField.valid) && (
              <Error>{municipalityField.valid}</Error>
            )}
          </WrapperSelect>
        </CustomInputsRow>
      </div>
    )
  }

  return (
    !loading &&
    tab === 'address' && (
      <Form>
        <FormInputs>
          <InputsSection>
            <h4>Morada de Contrato</h4>

            {_renderAddressInputs('contract')}
          </InputsSection>
          <InputsSection>
            <h4>Morada de Faturação</h4>

            <div className='rowsWrapper'>
              <CustomInputsRow column>
                <label>
                  Morada de faturação<b> *</b>
                </label>
                <RadiosWrapper>
                  <GhostRadioV2
                    small
                    type='radio'
                    name='contract_address_same'
                    label='Igual à morada de contrato'
                    selected={billingAddress.value === 'e'}
                    onClick={() =>
                      changeField('billing', 'billingAddress', 'e')
                    }
                  />
                  <GhostRadioV2
                    small
                    type='radio'
                    name='contract_address_different'
                    label='Diferente da morada de contrato'
                    selected={billingAddress.value === 'd'}
                    onClick={() =>
                      changeField('billing', 'billingAddress', 'd')
                    }
                  />
                </RadiosWrapper>
              </CustomInputsRow>

              {billingAddress.value === 'd' && _renderAddressInputs('billing')}
              <CustomInputsRow>
                <WrapperSelect>
                  <label>
                    Débito direto<b> *</b>
                  </label>
                  <RadiosWrapper>
                    <GhostRadioV2
                      small
                      type='radio'
                      label='Sim'
                      selected={directDebit.value === 'd'}
                      onClick={() => changeField('billing', 'directDebit', 'd')}
                    />
                    <GhostRadioV2
                      small
                      type='radio'
                      label='Não'
                      selected={!directDebit.value}
                      onClick={() =>
                        changeField('billing', 'directDebit', false)
                      }
                    />
                  </RadiosWrapper>
                </WrapperSelect>

                <WrapperSelect>
                  <label>
                    Fatura eletrónica<b> *</b>
                  </label>
                  <RadiosWrapper>
                    <GhostRadioV2
                      small
                      type='radio'
                      label='Sim'
                      selected={electronicBilling.value === 'e'}
                      onClick={() =>
                        changeField('billing', 'electronicBilling', 'e')
                      }
                    />
                    <GhostRadioV2
                      small
                      type='radio'
                      label='Não'
                      selected={!electronicBilling.value}
                      onClick={() =>
                        changeField('billing', 'electronicBilling', false)
                      }
                    />
                  </RadiosWrapper>
                </WrapperSelect>
              </CustomInputsRow>
            </div>
          </InputsSection>
        </FormInputs>
        {renderBtns()}
      </Form>
    )
  )
}

export default AddressForm



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/components/addressForm.js